/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateOrganisationIndex } from '../../axios/candidateOrganisationIndex'
import type {
	CandidateOrganisationIndexError,
	CandidateOrganisationIndexResponse,
} from '../../types/CandidateOrganisationIndex'

export const candidateOrganisationIndexQueryKey = () => [{ url: '/candidate-center/organisations' }] as const

export type CandidateOrganisationIndexQueryKey = ReturnType<typeof candidateOrganisationIndexQueryKey>

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidateOrganisationController.php CandidateOrganisationController::index */
export function candidateOrganisationIndexQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		CandidateOrganisationIndexResponse,
		AxiosError<CandidateOrganisationIndexError>,
		CandidateOrganisationIndexResponse,
		CandidateOrganisationIndexQueryKey
	>({
		queryKey: candidateOrganisationIndexQueryKey(),
		queryFn: ({ signal }) => candidateOrganisationIndex({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidateOrganisationController.php CandidateOrganisationController::index */
export function useCandidateOrganisationIndex<TSelectData = CandidateOrganisationIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidateOrganisationIndexResponse,
					AxiosError<CandidateOrganisationIndexError>,
					TSelectData,
					CandidateOrganisationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidateOrganisationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidateOrganisationIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidateOrganisationController.php CandidateOrganisationController::index */
export function useCandidateOrganisationIndexSuspense<TSelectData = CandidateOrganisationIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidateOrganisationIndexResponse,
					AxiosError<CandidateOrganisationIndexError>,
					TSelectData,
					CandidateOrganisationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidateOrganisationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidateOrganisationIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
